import { useEffect, useState } from "react";

import { useSearchParams } from "react-router-dom";

import { useDeclineResetPasswordMutation } from "@sso/apis/resetPassword";
import { CommonPagesContent } from "@sso/components/CommonPagesContent";
import { notificationsMsgs, QueryKeys } from "@sso/constant";
import { CommonPageMessageType } from "@sso/types";

export const DeclineResetPassword = () => {
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState<CommonPageMessageType>(null);

  const [declineResetLink, { isLoading }] = useDeclineResetPasswordMutation();

  const key = searchParams.get(QueryKeys.KEY);
  const secret = searchParams.get(QueryKeys.SECRET);

  useEffect(() => {
    const handleSendRequest = async () => {
      if (!key || !secret) {
        return setMessage({ header: "Sorry", title: notificationsMsgs.WRONG_URL_ADDRESS });
      }
      try {
        await declineResetLink({ key, secret }).unwrap();
        setMessage({ header: "Thanks for Letting Us Know", title: notificationsMsgs.DECLINE_RESET_PASSWORD });
      } catch (error) {
        setMessage({ header: "Oops!", title: notificationsMsgs.DEFAULT_ERROR });
      }
    };
    handleSendRequest();
  }, [declineResetLink, key, secret]);

  return <CommonPagesContent loading={isLoading} message={message} />;
};
